import { detectIncognito } from 'detectincognitojs';

export interface BrowserDetectionResult {
  isPrivate: boolean;
  browserName: string;
}

export async function initBrowserDetection(): Promise<BrowserDetectionResult> {
  try {
    const { isPrivate, browserName } = await detectIncognito();
    return { isPrivate, browserName };
  } catch {
    console.warn('Browser detection failed, defaulting to private mode.');
    return { isPrivate: true, browserName: 'unknown' };
  }
}
